import axiosInstance from './axiosInstance';

// Events — a series (`event`) with dated sessions under it, booking and
// engagement per session, chat per series. Every endpoint resolves the event's own
// audience server-side, so a private event stays private even if a page is opened by id.

export const getMyEvents = () => axiosInstance.get('/Event/GetMine');
export const getAllEvents = () => axiosInstance.get('/Event/GetAll');
export const getEvent = (eventId) => axiosInstance.get(`/Event/GetById?eventId=${eventId}`);

export const saveEvent = (payload) => axiosInstance.post('/Event/Save', payload);
export const publishEvent = (eventId) => axiosInstance.post(`/Event/Publish?eventId=${eventId}`);
// Super Admin only. Approve runs the ordinary publish, so an approved event goes out
// through exactly the same path as one published directly.
export const approveEvent = (eventId) => axiosInstance.post(`/Event/Approve?eventId=${eventId}`);
export const rejectEvent = (eventId, remarks) =>
    axiosInstance.post(`/Event/Reject?eventId=${eventId}&remarks=${encodeURIComponent(remarks || '')}`);

export const deleteEvent = (eventId) => axiosInstance.post(`/Event/Delete?eventId=${eventId}`);

// Banner: an image, 5 MB - it is shown across the dashboard, so size matters.
export const uploadEventBanner = (file) => {
    const fd = new FormData();
    fd.append('file', file);
    return axiosInstance.post('/Event/UploadBanner', fd, {
        headers: { 'Content-Type': 'multipart/form-data' },
    });
};

// Material people download - a PDF deck, a checklist. 20 MB.
export const uploadEventMaterial = (file) => {
    const fd = new FormData();
    fd.append('file', file);
    return axiosInstance.post('/Event/UploadMaterial', fd, {
        headers: { 'Content-Type': 'multipart/form-data' },
    });
};

export const setEventStatus = (eventId, status) =>
    axiosInstance.post(`/Event/SetStatus?eventId=${eventId}&status=${encodeURIComponent(status)}`);

// "This reaches N people" before publishing — the same resolver the real audience uses,
// so the preview can't disagree with what actually goes out.
export const previewAudience = (payload) => axiosInstance.post('/Event/PreviewAudience', payload);

export const joinSession = (eventSessionId) => axiosInstance.post('/Event/Join', { eventSessionId });
export const cancelJoin = (eventSessionId) => axiosInstance.post('/Event/CancelJoin', { eventSessionId });

export const getRegistrations = (eventSessionId) =>
    axiosInstance.get(`/Event/GetRegistrations?eventSessionId=${eventSessionId}`);
export const decideRegistration = ({ eventRegistrationId, status, remarks }) =>
    axiosInstance.post('/Event/DecideRegistration', { eventRegistrationId, status, remarks });

// One tick from the player. Carries the DELTA since the last tick, never a running
// total — the server clamps it, so the record can't be inflated from the browser.
export const sendHeartbeat = ({ eventSessionId, deltaSeconds, positionSeconds, focused, videoLengthSeconds }) =>
    axiosInstance.post('/Event/Heartbeat', { eventSessionId, deltaSeconds, positionSeconds, focused, videoLengthSeconds });

// Polling cursor: pass the highest id already held. Returns [] almost every time.
export const getChat = ({ eventId, eventSessionId, afterId = 0, allSessions = false }) => {
    const qs = new URLSearchParams({ eventId, afterId, allSessions });
    if (eventSessionId) qs.append('eventSessionId', eventSessionId);
    return axiosInstance.get(`/Event/GetChat?${qs.toString()}`);
};
export const postChat = ({ eventId, eventSessionId, body, parentMessageId, isAiAssisted }) =>
    axiosInstance.post('/Event/PostChat', { eventId, eventSessionId, body, parentMessageId, isAiAssisted });
export const moderateChat = ({ eventChatMessageId, isPinned, isAnswered, del }) =>
    axiosInstance.post('/Event/ModerateChat', { eventChatMessageId, isPinned, isAnswered, delete: del });

export const getMyActivity = () => axiosInstance.get('/Event/MyActivity');
export const getAllActivity = ({ eventId, from, to } = {}) => {
    const qs = new URLSearchParams();
    if (eventId) qs.append('eventId', eventId);
    if (from) qs.append('from', from);
    if (to) qs.append('to', to);
    const q = qs.toString();
    return axiosInstance.get(`/Event/AllActivity${q ? `?${q}` : ''}`);
};
